import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Utilityservice } from '../../utility/utilityservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrganisationService } from '../../main-layout/organisation/organisation.service';

@Component({
  selector: 'app-orgtrainingmodal',
  templateUrl: './orgtrainingmodal.component.html',
  styleUrls: ['./orgtrainingmodal.component.css']
})
export class OrgtrainingmodalComponent {
  commonScrollHeight=''
  tableData=[];
  _selectedColumns=[]
  cols=[];
  paginatorArray=[];
   first2: number = 0;
  rows2: number = 10;
  totalRecords: number= 0;
  orgid=''
  constructor(private config:DynamicDialogConfig,public utilityservice:Utilityservice,
    private spinnerservice:NgxSpinnerService,private orgservice:OrganisationService){
     const datafromparent=this.config.data;     
     console.log(datafromparent,"datafrom");
     this.orgid=datafromparent.orgid
     this.tableData=datafromparent.list;
          console.log(this.tableData,"tableData");

     

  }
    ngOnInit() {
      this.dynamiccols()
    this.commonScrollHeight=this.utilityservice.updateScrollHeight();
    this.getgriddata()
}
dynamiccols(){
  //  enterprise C Cloud else  Enterprise
  // trainingtype= U user else Admin
  // trainingmedium = O Online else In Person
  this.cols=[
    {field:'name',header:'Oganisation',type:'Number',sort: true , filter:true, width:'2px !important',isChecked:true, class:'headerid'},
    {field:'type',header:'Traning Type',type:'text',sort: true , filter:true, width:'2px !important',isChecked:true, class:'otherheader'},
    { field: "enterpricedata", header: "C/E",type:'Date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "medium", header: "Medium",type:'Date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "fromdate", header: "Date",type:'Date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "time", header: "Time",type:'Date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "numberattended", header: "Attendend",type:'Date',sort: true ,filter:true, width:'20px',isChecked:true,class:'otherheader' } ,
    { field: "traininghours", header: "Trainig Hours",type:'text',sort: false , filter:false, width:'20px',isChecked:true,class:'otherheader' } 
  ]
 this._selectedColumns = this.cols;
}

handlePageChange(event: any) {
  this.rows2=event.rows
}
options=[]
getgriddata(){
      this.spinnerservice.show()
  this.orgservice.gettraingsdatabyorgid(this.orgid).subscribe(res=>{
  this.tableData=res
  console.log(this.tableData,"tabledata");
  this.tableData.map(e=>{
    if(e.enterprise=='C'){
      e['enterpricedata']='Cloud'
    } else{
        e['enterpricedata']='Enterprise'

    }
     if(e.trainingtype=='U'){
      e['type']='User'
     }else{
      e['type']='Admin'
     }
     if(e.trainingmedium=='O'){
      e['medium']='Online'
     }
     else{
        e['medium']='In Person'

     }
  })
  
  
  this.spinnerservice.hide();
  this.options=  this.utilityservice.getOptionDropdown(res.length);
        this.paginatorArray=this.options.map(e=>e.value)
  })
}

}
